module.exports = __webpack_public_path__ + "static/img/software2.98bd502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software2.jpg
// module id = 4WZT
// module chunks = 2